export const commonLocale = {
    cn: {
        taskAccessDenied: '您没有权限访问此任务。',
        lsAgent: {
            LCA_V2: {
                name: 'LCA 小分子（Beta）',
                desc: '分析专利中的化合物结构与实验数据，识别最具潜力的先导化合物，为研发决策与竞争情报提供可落地的洞察。',
            },
        },
    },
    en: {
        taskAccessDenied: 'You do not have permission to access this task.',
        lsAgent: {
            LCA_V2: {
                name: 'LCA Small Molecule (Beta)',
                desc: 'Analyzes patent\'s structural & experimental data, identify the most likely lead compounds for actionable, competitive insights',
            },
        },
    },
    jp: {
        taskAccessDenied: 'このタスクにアクセスする権限がありません。',
        lsAgent: {
            LCA_V2: {
                name: 'LCA 低分子医薬品（Beta）',
                desc: '特許に記載された化合物構造と実験データを解析し、有望なリード化合物を特定。研究開発の意思決定と競合分析に活用できる実践的なインサイトを提供します。',
            },
        },
    },
    tw: {
        taskAccessDenied: '您沒有權限存取此任務。',
        lsAgent: {
            LCA_V2: {
                name: 'LCA 小分子（Beta）',
                desc: '分析專利中的化合物結構與實驗數據，識別最具潛力的先導化合物，為研發決策與競爭情報提供可落地的洞察。',
            },
        },
    },
} as const
